import * as React from "react"
import { SVGProps } from "react"

const SvgViewOff = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12.29 5.4c.38.34.7.67.94.93a1 1 0 0 1 0 1.34C12.18 8.8 9.79 11 7 11h-.4M3.87 10.13a12.4 12.4 0 0 1-3.1-2.46 1 1 0 0 1 0-1.34C1.82 5.2 4.21 3 7 3a6.56 6.56 0 0 1 3.13.87M12.5 1.5l-11 11" />
      <path d="M5.59 8.41A2 2 0 0 1 5 7a2 2 0 0 1 2-2 2 2 0 0 1 1.41.59M8.74 8a2 2 0 0 1-.74.73" />
    </g>
  </svg>
)
export default SvgViewOff
